var _g, _g2, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInviteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 190,
    viewBox: "0 0 180 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2073_15486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.337 109.263H120.29C120.29 79.3662 96.0271 55.0341 66.2157 55.0341C36.4043 55.0341 12.1416 79.3662 12.1416 109.263H10.0941C10.0941 78.2368 35.2782 52.9808 66.2157 52.9808C97.1533 52.9808 122.337 78.2368 122.337 109.263Z",
    fill: "#D3FF9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.49 108.236H6.94098C5.07777 108.236 3.3374 108.955 2.00654 110.289C0.71662 111.624 0 113.369 0 115.217C0 119.057 3.11218 122.178 6.94098 122.178H125.49C127.374 122.178 129.115 121.46 130.404 120.125C131.735 118.811 132.452 117.065 132.452 115.217C132.452 111.378 129.319 108.236 125.49 108.236ZM128.951 118.688C128.05 119.612 126.821 120.125 125.49 120.125H6.94098C4.2383 120.125 2.04749 117.928 2.04749 115.217C2.04749 113.903 2.55936 112.671 3.46025 111.727C4.4021 110.803 5.63059 110.289 6.94098 110.289H125.49C128.193 110.289 130.404 112.507 130.404 115.217C130.404 116.511 129.893 117.743 128.951 118.688Z",
    fill: "#D3FF9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7539 120.427L10.3062 121.878L23.0178 134.626L24.4656 133.174L11.7539 120.427Z",
    fill: "#D3FF9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.996 120.427L107.98 133.48L109.428 134.932L122.444 121.879L120.996 120.427Z",
    fill: "#D3FF9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2157 190C42.2396 190 22.7476 170.452 22.7476 146.408V120.248H109.684V146.408C109.684 170.452 90.1918 190 66.2157 190ZM24.795 122.322V146.428C24.795 169.323 43.3862 187.967 66.2157 187.967C89.0452 187.967 107.636 169.323 107.636 146.428V122.322H24.795Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2073_15486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.077 0.913452H96.2288C89.9533 0.913452 84.8654 6.00143 84.8654 12.2769V39.3428C84.8654 45.6183 89.9533 50.7062 96.2288 50.7062H114.343L131.653 68.0163L148.963 50.7062H167.077C173.352 50.7062 178.44 45.6183 178.44 39.3428V12.2769C178.44 6.00143 173.352 0.913452 167.077 0.913452Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M131.452 31.9042C129.43 31.9042 127.798 30.3269 127.798 28.4055V19.0276C127.798 17.1062 129.445 15.5288 131.452 15.5288C133.459 15.5288 135.106 17.1062 135.106 19.0276V28.4055C135.106 30.3413 133.459 31.9042 131.452 31.9042ZM131.452 16.9628C130.269 16.9628 129.296 17.8948 129.296 19.0276V28.4055C129.296 29.5526 130.269 30.4703 131.452 30.4703C132.635 30.4703 133.608 29.5383 133.608 28.4055V19.0276C133.608 17.8805 132.635 16.9628 131.452 16.9628Z",
    fill: "#D3FF9A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M131.452 40.1923C129.43 40.1923 127.798 38.615 127.798 36.6935C127.798 34.7721 129.445 33.1948 131.452 33.1948C133.459 33.1948 135.106 34.7721 135.106 36.6935C135.106 38.615 133.459 40.1923 131.452 40.1923ZM131.452 34.6287C130.269 34.6287 129.296 35.5607 129.296 36.6935C129.296 37.8263 130.269 38.7584 131.452 38.7584C132.635 38.7584 133.608 37.8263 133.608 36.6935C133.608 35.5607 132.635 34.6287 131.452 34.6287Z",
    fill: "#D3FF9A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2073_15486"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 132.452,
    height: 137.019,
    fill: "white",
    transform: "translate(0 52.9808)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2073_15486"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 95.4019,
    height: 68.9298,
    fill: "white",
    transform: "translate(83.9519)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteIcon);
export default __webpack_public_path__ + "static/media/invite-icon.c597c54f60877dc07fdaf19eae9a4000.svg";
export { ForwardRef as ReactComponent };